(function () {
  if (customElements.get('ce-header-mobile-child-menu') !== undefined) {
    return;
  }

  class HeaderMobileChildMenu extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        focusTrap: '[data-focus-trap]',
        details: '[data-header-mobile-child-menu-details]',
        panel: '[data-header-mobile-child-menu-panel]',
        buttonOpen: '[data-header-mobile-child-menu-button-open]',
        buttonClose: '[data-header-mobile-child-menu-button-close]',
        scrollContainer: '[data-header-mobile-child-menu-scroll-container]',
      };

      this.elements = null;

      this.handleClickButtonOpen = this.handleClickButtonOpen.bind(this);
      this.handleClickButtonClose = this.handleClickButtonClose.bind(this);
    }

    get isOpen() {
      return this.getAttribute('is-open') === 'true';
    }

    set isOpen(value) {
      this.setAttribute('is-open', value);
    }

    get willTrapFocus() {
      return this.getAttribute('will-trap-focus') == 'true';
    }

    set willTrapFocus(value) {
      this.setAttribute('will-trap-focus', value);
    }

    static get observedAttributes() {
      return ['is-open'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-open':
          if (newValue !== null) {
            if (newValue === 'true') {
              if (this.willTrapFocus) {
                trapFocus(this.elements.focusTrap, { elementToFocus: this.elements.buttonClose });
              }

              this.elements.buttonOpen.setAttribute('aria-expanded', 'true');
              this.elements.buttonClose.setAttribute('aria-expanded', 'true');
            } else {
              if (this.willTrapFocus) {
                trapFocus(this.elements.parentFocusTrap, { elementToFocus: this.elements.buttonOpen });
                this.elements.scrollContainer.scrollTo(0, 0);
              }

              this.elements.buttonOpen.setAttribute('aria-expanded', 'false');
              this.elements.buttonClose.setAttribute('aria-expanded', 'false');

              this.elements.details.removeAttribute('open');
            }
          }

          break;
      }
    }

    parsedCallback() {
      const focusTrap = this.querySelector(this.selectors.focusTrap);
      const level = focusTrap.dataset.focusTrap;
      const parentLevel = parseInt(level) - 1;

      this.elements = {
        parentFocusTrap: document.querySelector(`[data-focus-trap='${parentLevel}']`),
        focusTrap: focusTrap,
        details: this.querySelector(this.selectors.details),
        panel: this.querySelector(this.selectors.panel),
        buttonOpen: this.querySelector(this.selectors.buttonOpen),
        buttonClose: this.querySelector(this.selectors.buttonClose),
        scrollContainer: this.querySelector(this.selectors.scrollContainer),
        animationTargets: this.querySelectorAll(`[data-header-mobile-child-menu-animation-target='${level}']`),
      };

      this.elements.buttonOpen.addEventListener('click', this.handleClickButtonOpen);
      this.elements.buttonClose.addEventListener('click', this.handleClickButtonClose);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.buttonOpen.removeEventListener('click', this.handleClickButtonOpen);
      this.elements.buttonClose.removeEventListener('click', this.handleClickButtonClose);
    }

    handleClickButtonOpen(event) {
      event.preventDefault();

      this.elements.details.setAttribute('open', '');

      const keyframes = [{ transform: 'translateX(calc(100% + 5px))', transform: 'translateX(0)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 300,
        easing: Themu.animation.easeIn,
        fill: 'both',
      };

      const animation = this.elements.panel.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        animation.commitStyles();
        animation.cancel();

        this.isOpen = true;
      });

      for (let i = 0; i < this.elements.animationTargets.length; i++) {
        this._playAnimationOpenListItem(this.elements.animationTargets[i], i);
      }
    }

    handleClickButtonClose() {
      const keyframes = [{ transform: 'translateX(0)', transform: 'translateX(calc(100% + 5px))' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 200,
        easing: Themu.animation.easeOut,
        fill: 'both',
      };

      const animation = this.elements.panel.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        animation.commitStyles();
        animation.cancel();

        this.isOpen = false;
      });
    }

    close() {
      if (!this.parsed) {
        return;
      }

      this.elements.panel.style.transform = 'translateX(calc(100% + 5px))';
      this.isOpen = false;
    }

    _playAnimationOpenListItem(target, i) {
      const keyframes = [
        { opacity: 0, transform: 'translateX(48px)' },
        { opacity: 1, transform: 'translateX(0)' },
      ];

      const options = {
        delay: 100 + 50 * i,
        duration: Themu.prefersReducedMotion ? 0 : 200,
        easing: Themu.animation.easeIn,
        fill: 'both',
      };

      const animation = target.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        animation.commitStyles();
        animation.cancel();
      });
    }
  }

  customElements.define('ce-header-mobile-child-menu', HeaderMobileChildMenu);
})();
